module.exports = __webpack_public_path__ + "static/ue-fund-73e2d74d7b080c072a431dda7dae673a.png";